import { releaseStatusLabel, releaseStatusTone } from "./releaseFormat.js";
import styles from "./ReleaseStatusPill.module.scss";

// The release lifecycle STATUS PILL — the single presentation of a release status, reused by the
// hub card and the detail hero. The tone drives `[data-tone]` in the SCSS: gray DRAFT · crimson IN CYCLE ·
// green RELEASED · muted CANCELLED. On-token only (no literal colors — the tokens:audit firewall).

export function ReleaseStatusPill({ status }: { status: string | null | undefined }) {
  return (
    <span className={styles.pill} data-tone={releaseStatusTone(status)}>
      {releaseStatusLabel(status)}
    </span>
  );
}
